import { ActionType } from 'core/utils/interfaces'
import { actionCoreApi } from 'core/utils/api'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'
import ActionsList from './Actions.list'
import { actionErrorNotifier } from 'core/utils/helpers'

export const createCustomer = (formData: any): ActionType =>
actionErrorNotifier(
    actionCoreApi(
      ActionsList.CreateCustomer,
      HTTPUrlHelper.getCustomerAPI(),
      'POST',
      formData
    ), true,
    {
      title: '',
      message: 'notifications.accounts.createAccountSuccess'
    }
  )